module.exports = __webpack_public_path__ + "static/media/check-white.127ab292.svg";